import { AppThunk } from '../../../../store/types';
import { PlayerManager } from '../../../../effects/player/manager/playerManager';
import { getNativeCaptions, getTargetCaptions } from '../../../../store/videos/selectors';
import { getShowNativeCaptions, getUseShortcuts, isHoverAutoPause, isPauseOnNote } from '../../../../store/general/selectors';
import { UserSettingEffects } from '../../../../effects/userSettingEffects';
import { updateGeneralAction } from '../../../../store/general/actions';

export class CaptionsEvents {

  public static onKeyDown(): AppThunk {
    return (
      dispatch,
      getState
    ) => {
    }
  }

  public static onVideoChange(): AppThunk {
    return (
      dispatch,
      getState
    ) => {
    }
  }

  public static onTargetCaptionsChange(): AppThunk {
    return (
      dispatch,
      getState
    ) => {
      PlayerManager.getInstance().setTargetCaptions(getTargetCaptions(getState()));
    }
  }

  public static onNativeCaptionsChange(): AppThunk {
    return (
      dispatch,
      getState
    ) => {
      PlayerManager.getInstance().setNativeCaptions(getNativeCaptions(getState()));
    }
  }

  public static onShowNativeCaptionsChange(): AppThunk {
    return (
      dispatch,
      getState
    ) => {
      const show = getShowNativeCaptions(getState());
      UserSettingEffects.setShowNativeCaptions(!show);
    }
  }

  public static onHoverAutoPauseChange(): AppThunk {
    return (
      dispatch,
      getState
    ) => {
      const pause = isHoverAutoPause(getState());
      UserSettingEffects.setHoverAutoPause(!pause);
    }
  }

  public static onAutoPauseChange(): AppThunk {
    return (
      dispatch,
      getState
    ) => {
      UserSettingEffects.setAutoPause(0);
    }
  }

  public static onAutoPauseNotesChange(): AppThunk {
    return (
      dispatch,
      getState
    ) => {
      const value = isPauseOnNote(getState());
      UserSettingEffects.setPauseOnNote(!value);
    }
  }

  public static onTargetCaptionIndexChange(index: number): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
    }
  }

  public static onToggleShortcuts(): AppThunk {
    return (
      dispatch,
      getState
    ) => {
      dispatch(updateGeneralAction({ useShortcuts: !getUseShortcuts(getState()) }));
    }
  }

}
